import { useSelector, useDispatch } from "react-redux";
// import { ReactCountryDropdown } from "react-country-dropdown";
// import "react-country-dropdown/dist/index.css";
import React, { useState, useEffect } from "react";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputAdornment,
	IconButton,
	FormControl,
	InputLabel,
	Input
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FormGroup, Row, Col } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import { Card } from "reactstrap";
import { countries } from "../../utils/countriesDropdown";
import { IoMdSend } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Alert } from "reactstrap";
import { addOrUpdateUserManagement } from "../../redux/actions/addOrUpdateUserManagementAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SaveIcon from "@mui/icons-material/Save";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../utils/helper/index";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

export default function AddUserManagement() {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [userName, setUserName] = useState("");
	const [password, setPassword] = useState("");
	const [cnfmPassword, setCnfmPassword] = useState("");
	const [role, setRole] = useState("");
	const [fullName, setFullName] = useState("");
	const [email, setEmail] = useState("");
	const [phoneNo, setPhoneNo] = useState("");
	const [address, setAddress] = useState("");
	const [country, setCountry] = useState("");
	const [state, setState] = useState("");
	const [city, setCity] = useState("");
	const [postalCode, setPostalCode] = useState("");
	const [disablebtn, setDisablebtn] = useState("");
	const [addUserManagementRes, setaddUserManagementRes] = useState("");
	const [hiddenPassword, setHiddenPassword] = useState("true");
	const [hiddenConPassword, setHiddenConPassword] = useState("true");
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};
	const handleChange = ({ target: { name, value } }) => {
		if (name === "userName") {
			setUserName(value);
		}
		if (name === "password") {
			setPassword(value);
		}

		if (name === "role") {
			setRole(value == "Select Role" ? "" : value);
		}

		if (name === "cnfmPassword") {
			setCnfmPassword(value);
		}

		if (name === "fullName") {
			setFullName(value);
		}

		if (name === "email") {
			setEmail(value);
		}

		if (name === "phoneNo") {
			setPhoneNo(value);
		}
		if (name === "address") {
			setAddress(value);
		}

		if (name === "country") {
			setCountry(value == "Select Country" ? "" : value);
		}
		if (name === "state") {
			setState(value);
		}
		if (name === "city") {
			setCity(value);
		}
		if (name === "postalCode") {
			setPostalCode(value);
		}
	};

	// const addOrUpdateUserManagementRes = useSelector(
	//   ({ addOrUpdateUserManagement }) => addOrUpdateUserManagement
	// );

	// const addUserManagementFunc = () => {
	//   setaddUserManagementRes(true);

	//   // Add request here
	//   const addUserManagementReq = {
	//     loginDetails: {
	//       walletOwnerId: "1",
	//     },
	//     actionCustomerMasterRequestVO: {},
	//   };
	//   return dispatch(addOrUpdateUserManagement(addUserManagementReq, authToken));
	// };
	const handleSelect = (country) => {
		console.log(country);
	};

	const togglePassword = (e) => {
		e.preventDefault();
		setHiddenPassword((state) => !state);
	};

	const toggleConPassword = (e) => {
		e.preventDefault();
		setHiddenConPassword((state) => !state);
	};

	const saveBtn = () => {
		if (
			userName == "" ||
			password == "" ||
			cnfmPassword == "" ||
			role == "" ||
			fullName == "" ||
			country == "" ||
			address == ""
		) {
			return true;
		}
		return false;
	};

	// useEffect(() => {
	//   if (addUserManagementRes) {
	//     addOrUpdateUserManagementResFunc();
	//   }
	// }, [addOrUpdateUserManagementRes.data.status]);

	// const addOrUpdateUserManagementResFunc = () => {
	//   if (addUserManagementRes) {
	//     if (addOrUpdateUserManagementRes.data.status == "success") {
	//       setaddUserManagementRes(addOrUpdateUserManagementRes.data);
	//       setNotificationOpen(true);
	//     }
	//     if (addOrUpdateUserManagementRes.data.status == "failed") {
	//       setaddUserManagementRes(addOrUpdateUserManagementRes.data);
	//       setNotificationOpen(true);
	//     }
	//   }
	// };

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<Grid container>
						<Grid item lg={12} md={12} sm={12}>
							<h6 align="center" className="text-center themeText">
								Add New User
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Username"
									fullWidth={true}
									name="userName"
									value={userName || ""}
									onChange={handleChange}
								/>
							</div>
							{/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  required
                  helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
                  type="password"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Password"
                  fullWidth={true}
                  name="password"
                  value={password || ""}
                  onChange={handleChange}
                />
              </div> */}

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
											type={hiddenPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Password"
											fullWidth={true}
											name="password"
											id="password"
											value={password}
											onChange={handleChange}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={togglePassword}
															onMouseDown={togglePassword}
														>
															{hiddenPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												)
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Should be same as Password)"
											type={hiddenConPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Confirm Password"
											fullWidth={true}
											name="cnfmPassword"
											id="cnfmPassword"
											value={cnfmPassword}
											onChange={handleChange}
											error={
												password &&
													password !== cnfmPassword &&
													cnfmPassword ? (
													<p
														className="passwordNotMatch"
														style={{ color: "red" }}
													>
														{"Password did not match"}
													</p>
												) : (
													""
												)
											}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={toggleConPassword}
															onMouseDown={toggleConPassword}
														>
															{hiddenConPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												)
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							{/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  required
                  helperText="(Should be same as PASSWORD)"
                  type="password"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Confirm Password"
                  fullWidth={true}
                  name="cnfmPassword"
                  value={cnfmPassword || ""}
                  onChange={handleChange}
                />
              </div> */}
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Role"
									fullWidth={true}
									name="role"
									defaultValue={"Select Role" || role}
									onChange={handleChange}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									<MenuItem value="SubOwner">SubOwner</MenuItem>
									<MenuItem value="Cashier">Cashier</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Full Name"
									fullWidth={true}
									name="fullName"
									value={fullName || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Email"
									fullWidth={true}
									name="email"
									value={email || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Phone Number"
									fullWidth={true}
									name="phoneNo"
									value={phoneNo || ""}
									onChange={handleChange}
								></TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Address"
									fullWidth={true}
									name="address"
									value={address || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="string"
									label="Country"
									fullWidth={true}
									name="country"
									// value={country}
									defaultValue={"Select Country" || country}
									onChange={handleChange}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>

									{countries.map((value) => (
										<MenuItem value={value.label + value.dial_code}>
											{value.label}
										</MenuItem>
									))}

									{/* <MenuItem value="India">India</MenuItem>
                  <MenuItem value="USA">USA</MenuItem>
                  <MenuItem value="England">England</MenuItem> */}
								</TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="State"
									fullWidth={true}
									name="state"
									value={state || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="City"
									fullWidth={true}
									name="city"
									value={city || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Postal Code"
									fullWidth={true}
									name="postalCode"
									value={postalCode || ""}
									onChange={handleChange}
								/>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
                  disabled={saveBtn()}
                  style={{
                    // marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  // color="primary"
                  // onClick={addUserManagementFunc}
                  endIcon={<SaveIcon />}
                >
                  Save
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
								// onClick={addUserManagementFunc}
								// endIcon={<SaveIcon />}
								>
									Save <SaveIcon />
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{addUserManagementRes.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addUserManagementRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addUserManagementRes.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addUserManagementRes.result.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}
